// Tiny localStorage cache for the dashboard's "who is logged in?" header.
// Lets the sidebar hydrate the user's name / email / avatar / business name
// instantly on dashboard re-mount, before the real API calls return.
//
// Backed by best-effort writes — corruption or quota errors are swallowed.

const KEY = 'nudge.profile.cache'

export type ProfileCache = {
  firstName?: string | null
  lastName?: string | null
  email?: string | null
  avatarUrl?: string | null
  businessName?: string | null
  businessLogoUrl?: string | null
  isAdmin?: boolean
}

export function readProfileCache(): ProfileCache | null {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    return JSON.parse(raw) as ProfileCache
  } catch {
    return null
  }
}

export function writeProfileCache(patch: ProfileCache): void {
  try {
    const existing = readProfileCache() ?? {}
    const merged: ProfileCache = { ...existing, ...patch }
    localStorage.setItem(KEY, JSON.stringify(merged))
  } catch {
    /* ignore quota / serialization errors */
  }
}

export function clearProfileCache(): void {
  try {
    localStorage.removeItem(KEY)
  } catch {
    /* ignore */
  }
}
